export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
}
export function getFirstCapitalizedLetter(string) {
    for (var i = 0; i < string.length; i++) {
        var letter = string.charAt(i);
        if (letter !== ' ' && letter === letter.toUpperCase()) {
            return letter;
        }
    }
    return string[0];
}
/**
 * Given a string value, return a normalized version of it, which implies
 * using a standard version for any accents such as 'ó', using lowerCase,
 * and removing all diacritics/special characters
 *
 * @param value - the string to normalize
 */
export function normalize(value) {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
}
